import { cloneDeepWith } from "lodash";

export function omitDeep<T>(collection: T, ...excludeKeys: string[]) {
  function omitFn(value: any) {
    if (value && typeof value === "object") {
      excludeKeys.forEach((key) => {
        delete value[key];
      });
    }
  }

  return cloneDeepWith(collection, omitFn);
}
